export const CONTACT = {
  phone: "0753 560 662",
  email: "contact@heavymetal.ro",
  phoneHref: "tel:+40753560662",
  whatsapp:
    "https://wa.me/40753560662?text=Bun%C4%83%20ziua%2C%20doresc%20o%20ofert%C4%83%20pentru%20un%20proiect%20metalic.",
  address: "Strada Islazului nr. 4A, Buzău",
  mapsUrl:
    "https://www.google.com/maps?q=Strada+Islazului+4A,+Buz%C4%83u&output=embed",
  hours: [
    { days: "Luni – Vineri", time: "08:00 – 20:00" },
    { days: "Sâmbătă", time: "08:00 – 14:00" },
    { days: "Duminică", time: "Închis" },
  ],
};

export const SERVICES = [
  {
    slug: "debitare-laser",
    name: "Debitare Laser",
    short: "Tăiere de precizie CNC în oțel, inox, aluminiu, corten și alamă.",
    image: "/images/laser.jpg",
    hero: "/images/laser.jpg",
    description:
      "Debitarea laser este inima atelierului nostru. Tăiem tablă din oțel carbon, inox, aluminiu, corten și alamă cu precizie de ±0,5 mm, la viteze care transformă un desen tehnic în piesă finită în aceeași zi.",
    longDescription:
      "Fie că ai nevoie de o singură piesă prototip sau de o serie de mii de componente, echipamentele noastre laser livrează muchii curate, fără bavuri, gata de îndoire sau sudură. Lucrăm direct din fișierele tale DXF, DWG sau STEP — sau pornim de la o schiță și o transformăm împreună într-un proiect executabil.",
    features: [
      { title: "Precizie ±0,5 mm", text: "Toleranțe strânse pentru ansambluri care se potrivesc perfect din prima." },
      { title: "Oțel, inox, aluminiu, corten, alamă", text: "Tablă de la 0,5 mm până la 20 mm, în funcție de material." },
      { title: "Forme complexe", text: "Contururi, decupaje fine și modele decorative imposibil de obținut clasic." },
      { title: "Serii mici și mari", text: "De la prototip unic la producție de serie cu cost optimizat pe piesă." },
    ],
    process: [
      "Primești consultanță și ofertă pe baza fișierelor sau schiței tale",
      "Optimizăm așezarea pieselor pe tablă pentru pierderi minime de material",
      "Debitare laser și control calitate pe fiecare lot",
      "Predare rapidă sau continuare către îndoire, sudură și vopsire",
    ],
  },
  {
    slug: "indoire-abkant",
    name: "Îndoire Abkant CNC",
    short: "Îndoiri precise, unghiuri perfecte, repetabilitate totală.",
    image: "/images/abkant.jpg",
    hero: "/images/abkant.jpg",
    description:
      "Presa abkant CNC transformă tabla debitată în corpuri tridimensionale: profile, carcase, console și elemente structurale cu unghiuri constante pe toată lungimea.",
    longDescription:
      "Cu presiune controlată electronic și scule dedicate, realizăm îndoiri simple sau secvențe complexe de mai multe fălțuri. Fiecare îndoire este calculată pentru a compensa revenirea elastică a materialului, astfel încât cota finală să fie exact cea din desen.",
    features: [
      { title: "Unghiuri constante", text: "Control CNC al adâncimii pentru repetabilitate pe serii întregi." },
      { title: "Îndoiri multiple", text: "Secvențe de fălțuri pentru profile complexe, carcase și rame." },
      { title: "Piese lungi", text: "Îndoire pe lungimi de până la 3 metri, grosimi până la 12 mm." },
      { title: "Flux complet", text: "Debitare + îndoire în același atelier, fără transport între furnizori." },
    ],
    process: [
      "Analizăm desenul și stabilim ordinea optimă a îndoirilor",
      "Îndoire CNC cu verificarea unghiurilor pe prima piesă",
      "Control dimensional final și ambalare pentru transport",
    ],
  },
  {
    slug: "vopsitorie-electrostatica",
    name: "Vopsitorie Electrostatică",
    short: "Finisaj durabil, culori RAL, aspect impecabil ani la rând.",
    image: "/images/vopsitorie.jpg",
    hero: "/images/vopsitorie.jpg",
    description:
      "Vopsirea în câmp electrostatic oferă metalului o peliculă uniformă, rezistentă la zgârieturi, UV și coroziune — finisajul standard pentru porți, garduri, mobilier și panouri decorative.",
    longDescription:
      "Piesele sunt degresate, apoi încărcate electrostatic cu pulbere care aderă uniform, inclusiv în muchii și colțuri. Coacerea la temperatură controlată transformă pulberea într-un strat continuu, rezistent. Poți alege orice culoare din paletarul RAL, în variantă mată, lucios sau texturată.",
    features: [
      { title: "Paletar RAL complet", text: "Sute de culori și texturi: mat, lucios, fine structure, marochin." },
      { title: "Rezistență extinsă", text: "Protecție UV și anticorozivă pentru exterior, garanție pe finisaj." },
      { title: "Acoperire uniformă", text: "Muchii, colțuri și zone greu accesibile acoperite perfect." },
      { title: "Piese mari", text: "Cuptor dimensionat pentru porți, garduri și structuri de mari dimensiuni." },
    ],
    process: [
      "Pregătire suprafață: degresare și pre-tratare pentru aderență maximă",
      "Aplicare pulbere electrostatică în cabină dedicată",
      "Coacere la temperatură controlată pentru polimerizare completă",
      "Inspecție vizuală și dimensională înainte de livrare",
    ],
  },
  {
    slug: "sudura",
    name: "Sudură MIG / TIG / LASER",
    short: "Cusături curate pe oțel, inox și aluminiu.",
    image: "/images/sudura.jpg",
    hero: "/images/sudura.jpg",
    description:
      "Trei tehnologii de sudură sub un singur acoperiș: MIG pentru structuri robuste, TIG pentru inox și aluminiu la calitate estetică, LASER pentru îmbinări fine aproape invizibile.",
    longDescription:
      "Sudorii noștri certificați aleg procedeul potrivit fiecărui proiect. Sudura MIG oferă viteză și rezistență pentru structuri. TIG livrează cusătura perfectă pentru inox vizibil și aluminiu. Sudura laser minimizează deformarea termică și aproape elimină finisajul ulterior.",
    features: [
      { title: "MIG/MAG", text: "Structuri, cadre și ansambluri din oțel carbon, rapid și economic." },
      { title: "TIG/WIG", text: "Inox și aluminiu cu aspect premium, ideal pentru elemente vizibile." },
      { title: "Sudură LASER", text: "Îmbinări de precizie cu zonă termică minimă și cusătură fină." },
      { title: "Ansambluri complete", text: "De la subansamblu sudat la structuri finite, gata de montaj." },
    ],
    process: [
      "Alegem procedeul și parametrii în funcție de material și destinație",
      "Fixare în dispozitive pentru eliminarea deformațiilor",
      "Sudare și curățare cusătură, șlefuire unde aspectul contează",
      "Verificare vizuală și dimensională a fiecărui ansamblu",
    ],
  },
];

export const PRODUCTS = [
  {
    slug: "mobilier-metalic",
    name: "Mobilier Metalic",
    short: "Piese unicat: mese, rafturi, corpuri cu structură din oțel.",
    image: "/images/mobilier.jpg",
    description:
      "Mobilier metalic proiectat și construit la comandă — de la mese cu structură din oțel și rafturi industriale, până la corpuri de depozitare și piese statement pentru spații comerciale.",
    features: [
      "Design personalizat pornind de la ideea sau schița ta",
      "Combinații metal + lemn, sticlă sau piatră",
      "Finisaj electrostatic în orice culoare RAL",
      "Rezistență structurală pentru uz intensiv",
    ],
  },
  {
    slug: "porti-garduri",
    name: "Porți & Garduri",
    short: "Porți batante sau culisante, garduri moderne sau clasice.",
    image: "/images/porti.jpg",
    description:
      "Porți și garduri care protejează și impresionează: modele moderne, clasice sau alese de tine.",
    features: [
      "Porți batante, culisante sau autoportante",
      "Panouri decorative tăiate laser cu modele proprii",
      "Pregătire pentru automatizări și interfoane",
      "Pregătite pentru montaj, cu plan de prindere",
    ],
  },
  {
    slug: "carport",
    name: "Carport",
    short: "Adăposturi auto metalice, moderne și durabile.",
    image: "/images/carport.jpg",
    description:
      "Carporturi metalice cu design minimalist, dimensionate pentru una sau mai multe mașini. Structură din oțel vopsit electrostatic, cu acoperiș plat sau ușor înclinat, integrat armonios în curtea ta.",
    features: [
      "Structură calculată pentru zăpadă și vânt",
      "Design modern cu stâlpi slim și acoperiș plat",
      "Opțiuni: panouri laterale, iluminat, încărcător EV",
      "Gata de montaj, cu plan de ancorare",
    ],
  },
  {
    slug: "balustrade",
    name: "Balustrade",
    short: "Balustrade interioare și exterioare, sigure și elegante.",
    image: "/images/balustrade.jpg",
    description:
      "Balustrade din oțel pentru scări, terase și balcoane. De la bare orizontale minimaliste la panouri pline tăiate laser, fiecare balustradă este construită pentru siguranță și aspect.",
    features: [
      "Oțel vopsit electrostatic, în orice nuanță RAL",
      "Modele cu bare, cabluri sau panouri decorative",
      "Conformitate cu normele de înălțime și rezistență",
      "Finisaj la cheie, pregătite pentru montaj",
    ],
  },
  {
    slug: "panouri-decorative",
    name: "Panouri Decorative",
    short: "Panouri tăiate laser pentru fațade, garduri și interioare.",
    image: "/images/panouri.jpg",
    description:
      "Panouri decorative tăiate laser cu modele geometrice, florale sau personalizate cu sigla ta. Folosite pentru fațade, garduri, separatoare de spații sau elemente de iluminat, transformă orice suprafață.",
    features: [
      "Modele din catalog sau design 100% personalizat",
      "Oțel corten, oțel vopsit sau aluminiu",
      "Dimensiuni mari, imbricare modulară",
      "Iluminare LED integrată opțional",
    ],
  },
  {
    slug: "terase",
    name: "Terase",
    short: "Terase și pergole metalice, rezistente la intemperii.",
    image: "/images/terase.jpg",
    description:
      "Terase și pergole cu structură din oțel, proiectate să reziste zeci de ani în exterior. De la pergola minimalistă cu lamele până la terasa acoperită complet, fiecare structură este dimensionată pentru spațiul și încărcările tale.",
    features: [
      "Structură din oțel vopsit electrostatic sau corten",
      "Pergole cu lamele fixe sau orientabile",
      "Rezistență la intemperii, UV și coroziune",
      "Integrare cu iluminat LED și închideri laterale",
    ],
  },
  {
    slug: "structuri-metalice",
    name: "Structuri Metalice",
    short: "Hale, șarpante, console și structuri de rezistență.",
    image: "/images/structuri.jpg",
    description:
      "Structuri metalice de rezistență pentru construcții civile și industriale: hale, șarpante, console, cadre și anexe. Executăm conform proiectului de arhitectură și rezistență și livrăm pregătite pentru montaj.",
    features: [
      "Hale, șarpante, console și cadre metalice",
      "Execuție strict conform proiectului tehnic",
      "Tratare anticorozivă și finisaj electrostatic",
      "Livrate cu documentație de montaj",
    ],
  },
  {
    slug: "mobilier-urban",
    name: "Mobilier Urban",
    short: "Bănci, coșuri, suporturi de biciclete și borduri.",
    image: "/images/mobilier-urban.jpg",
    description:
      "Mobilier urban robust pentru spații publice și private: bănci, coșuri de gunoi, suporturi de biciclete, stâlpi și borduri. Produse în serie sau personalizate, pentru primării, dezvoltatori și spații comerciale.",
    features: [
      "Bănci, coșuri, suporturi biciclete, stâlpi",
      "Oțel galvanizat și vopsit electrostatic",
      "Rezistență la vandalism și intemperii",
      "Serii pentru primării și dezvoltatori",
    ],
  },
];

export const NAV_SERVICES = SERVICES.map((s) => ({
  name: s.name,
  href: `/servicii/${s.slug}`,
}));

export const COUNTIES = [
  "Alba", "Arad", "Argeș", "Bacău", "Bihor", "Bistrița-Năsăud", "Botoșani",
  "Brașov", "Brăila", "București", "Buzău", "Caraș-Severin", "Călărași",
  "Cluj", "Constanța", "Covasna", "Dâmbovița", "Dolj", "Galați", "Giurgiu",
  "Gorj", "Harghita", "Hunedoara", "Ialomița", "Iași", "Ilfov", "Maramureș",
  "Mehedinți", "Mureș", "Neamț", "Olt", "Prahova", "Satu Mare", "Sălaj",
  "Sibiu", "Suceava", "Teleorman", "Timiș", "Tulcea", "Vaslui", "Vâlcea", "Vrancea",
];

export const PORTFOLIO_CATEGORIES = [
  "Porți & Garduri",
  "Terase",
  "Carporturi",
  "Balustrade",
  "Panouri Decorative",
  "Mobilier Metalic",
  "Structuri Metalice",
  "Mobilier Urban",
  "Confecții / Sudură",
  "Altele",
];

export const NAV_PRODUCTS = PRODUCTS.map((p) => ({
  name: p.name,
  href: `/produse/${p.slug}`,
}));
